const checkPristine = (initial, perms) => {
  if (initial.length === 0 || perms.length === 0) {
    return true;
  }

  for (const initPerm of initial) {
    const found = perms.find(p => {
      return p.resource_id === initPerm.resource_id;
    });

    if (found) {
      if (Array.isArray(found.value)) {
        if (found.value.join(',') !== initPerm.value.join(',')) {
          return false;
        }
      } else {
        const keys = Object.keys(found.value);

        for (const key of keys) {
          if (initPerm.value[key] !== found.value[key]) {
            return false;
          }
        }
      }
    }
  }

  return true;
};

export default checkPristine;
